import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ProductListForCreatePortfolio } from '../../../../../../model/finzy-flex/product-list.model';

@Component({
  selector: 'app-auto-portfolio-allocation',
  templateUrl: './auto-portfolio-allocation.component.html',
  styleUrls: ['./auto-portfolio-allocation.component.css']
})
export class AutoPortfolioAllocationComponent implements OnInit {
  private matDialogRef: MatDialogRef<AutoPortfolioAllocationComponent>;
  private router: Router;
  public lenderExposureAcrossP2PPlatforms: boolean = false;
  public productList: ProductListForCreatePortfolio[];
  public remainingWalletBalance: number;
  public walletAmountToShow: number = 0;
  constructor(
    router: Router,
    matDialogRef: MatDialogRef<AutoPortfolioAllocationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
        products: [],
        lenderExposureAcrossP2PPlatforms: boolean,
        remainingWalletBalance: number,
    }
  ) {
    this.router = router;
    this.matDialogRef = matDialogRef;
    this.lenderExposureAcrossP2PPlatforms = data.lenderExposureAcrossP2PPlatforms;
    this.productList = data.products;
    this.remainingWalletBalance = data.remainingWalletBalance;
    this.walletAmountToShow = Math.abs(this.remainingWalletBalance);
  }

  ngOnInit(): void {
  }

  onChangeAllocation () {
    return this.matDialogRef.close(false);
  }
  onInvestNow() {
    return this.matDialogRef.close(true);
  }

}
